import { isElectronApp } from "../../helpers/Utils";

// Either from electron app or web server
const getPath = (domain, url = "") => {
	const cleanUrl = url.startsWith("/") ? url.substring(1) : url;

	if (domain == "market") {
		const breadcrumbs = [""];
		breadcrumbs.push(domain);
		breadcrumbs.push(cleanUrl);
		return breadcrumbs.join("/");
	} else {
		const breadcrumbs = [""];
		if (isElectronApp()) breadcrumbs.push(domain);
		breadcrumbs.push(cleanUrl);
		return breadcrumbs.join("/");
	}

};

const PathHelper = {
	getPath,
};

export default PathHelper;
